module.exports = __webpack_public_path__ + "static/media/caret_down_tertiary.3e9108e7.svg";